import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

/* =========================================================
   SHARED COMPONENTS
========================================================= */

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";


/* =========================================================
   PUBLIC PAGES
========================================================= */

import Overview from "./pages/Overview/Overview";

import Services from "./pages/Services/Services";

import ServiceDetail from "./pages/ServiceDetails/ServiceDetails";

import Industries from "./pages/Industries/Industries";

import About from "./pages/About/About";

import Contact from "./pages/Contact/Contact";


/* =========================================================
   PUBLIC LAYOUT
========================================================= */

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />

      <main>
        {children}
      </main>

      <Footer />
    </>
  );
}


/* =========================================================
   SCROLL TO TOP
========================================================= */

function ScrollToTop() {

  const { pathname } = useLocation();

  useEffect(() => {

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

  }, [pathname]);

  return null;
}


/* =========================================================
   APP
========================================================= */

function App() {

  return (
    <>

      <ScrollToTop />


      <Routes>

        {/* =================================================
            OVERVIEW
        ================================================== */}

        <Route
          path="/"
          element={
            <PublicLayout>
              <Overview />
            </PublicLayout>
          }
        />

        <Route
          path="/overview"
          element={
            <PublicLayout>
              <Overview />
            </PublicLayout>
          }
        />


        {/* =================================================
            SERVICES
        ================================================== */}

        <Route
          path="/services"
          element={
            <PublicLayout>
              <Services />
            </PublicLayout>
          }
        />


        {/* =================================================
            SERVICE DETAILS
        ================================================== */}

        <Route
          path="/services/:serviceSlug"
          element={
            <PublicLayout>
              <ServiceDetail />
            </PublicLayout>
          }
        />


        {/* =================================================
            INDUSTRIES
        ================================================== */}

        <Route
          path="/industries"
          element={
            <PublicLayout>
              <Industries />
            </PublicLayout>
          }
        />


        {/* =================================================
            ABOUT
        ================================================== */}

        <Route
          path="/about"
          element={
            <PublicLayout>
              <About />
            </PublicLayout>
          }
        />


        {/* =================================================
            CONTACT
        ================================================== */}

        <Route
          path="/contact"
          element={
            <PublicLayout>
              <Contact />
            </PublicLayout>
          }
        />


        {/* =================================================
            FALLBACK
        ================================================== */}

        <Route
          path="*"
          element={
            <PublicLayout>
              <Overview />
            </PublicLayout>
          }
        />

      </Routes>

    </>
  );
}


export default App;